import { useMutation } from "@tanstack/react-query";
import { findDuplicates } from "../../../api/manual-import";
import { logAxiosError } from "../../../logging/logSentryError";
import { AxiosError } from "axios";
import { Errors } from "../../../types/api";

export const getFindDuplicatesMutation = () => useMutation({
    mutationFn: findDuplicates,
    onError: (e: AxiosError) => {
        if (e?.response?.status === Errors.InternalServerError) {
            logAxiosError(e);
        }
    }
});
